var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullAnimated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 157 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        #e4YK0t7jicV2_ts {animation: e4YK0t7jicV2_ts__ts 1000ms linear infinite normal forwards}\r\n        @keyframes e4YK0t7jicV2_ts__ts { 0% {transform: translate(78.000244px,17.4198px) scale(1,1)} 33.333333%\r\n        {transform: translate(78.000244px,17.4198px) scale(0.822504,0.822504);animation-timing-function:\r\n        cubic-bezier(0.68,-0.55,0.265,1.55)} 100% {transform: translate(78.000244px,17.4198px) scale(1,1)}}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e4YK0t7jicV2_ts",
    transform: "translate(78.5 18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78.5 -18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5879_17730",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1526 13.5443C25.1526 6.20334 19.7227 1.05423 12.8927 1.05423C6.09678 1.05423 0.564453 6.20334 0.564453 13.5443C0.564453 20.8852 6.09678 26.0691 12.8927 26.0691C19.6885 26.0691 25.1526 20.8852 25.1526 13.5443ZM6.54073 13.5443C6.54073 9.19539 8.99954 6.44688 12.8927 6.44688C16.7175 6.44688 19.2104 9.19539 19.2104 13.5443C19.2104 17.8236 16.7175 20.6417 12.8927 20.6417C8.99954 20.6417 6.54073 17.8236 6.54073 13.5443Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2077 25.8256H47.0132V14.4837C47.0132 9.26497 44.0763 6.20334 39.6709 6.20334C37.1096 6.20334 35.0606 7.35145 33.8995 8.98664V6.41209H28.0599V25.8256H33.8995V15.2839C33.8995 12.6397 35.3338 11.1785 37.5536 11.1785C39.7734 11.1785 41.2077 12.6397 41.2077 15.2839V25.8256Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7297 25.8256H56.5694V0.0800781H50.7297V25.8256Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2364 18.5542L64.831 6.41209H58.3083L66.0604 25.1646L61.6892 35.0453H67.9728L79.9254 6.41209H73.6076L69.2364 18.5542Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5353 9.16059V6.41209H81.6956V35.0801H87.5353V23.1119C88.5939 24.7471 90.6088 26.1039 93.4091 26.1039C98.0877 26.1039 101.81 22.2073 101.81 16.0841C101.81 9.96079 98.0877 6.13376 93.4091 6.13376C90.6088 6.13376 88.5939 7.45582 87.5353 9.16059ZM95.8679 16.0841C95.8679 19.1805 93.8872 20.92 91.6674 20.92C89.4818 20.92 87.5011 19.2153 87.5011 16.1188C87.5011 13.0224 89.4818 11.3177 91.6674 11.3177C93.8872 11.3177 95.8679 12.9876 95.8679 16.0841Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.532 25.8256H110.372V0.0800781H104.532V25.8256Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.101 16.0841C113.101 22.2073 116.824 26.1039 121.468 26.1039C124.302 26.1039 126.317 24.7819 127.376 23.0771V25.8256H133.216V6.41209H127.376V9.16059C126.351 7.45582 124.337 6.13376 121.502 6.13376C116.824 6.13376 113.101 9.96079 113.101 16.0841ZM127.376 16.1188C127.376 19.2153 125.429 20.92 123.21 20.92C121.024 20.92 119.043 19.1805 119.043 16.0841C119.043 12.9876 121.024 11.3177 123.21 11.3177C125.429 11.3177 127.376 13.0224 127.376 16.1188Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.875 18.5542L141.47 6.41209H134.947L142.699 25.1646L138.328 35.0453H144.612L156.564 6.41209H150.247L145.875 18.5542Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.1526 13.5443C25.1526 6.20334 19.7227 1.05423 12.8927 1.05423C6.09678 1.05423 0.564453 6.20334 0.564453 13.5443C0.564453 20.8852 6.09678 26.0691 12.8927 26.0691C19.6885 26.0691 25.1526 20.8852 25.1526 13.5443ZM6.54073 13.5443C6.54073 9.19539 8.99954 6.44688 12.8927 6.44688C16.7175 6.44688 19.2104 9.19539 19.2104 13.5443C19.2104 17.8236 16.7175 20.6417 12.8927 20.6417C8.99954 20.6417 6.54073 17.8236 6.54073 13.5443Z",
    stroke: "url(#paint0_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2077 25.8256H47.0132V14.4837C47.0132 9.26497 44.0763 6.20334 39.6709 6.20334C37.1096 6.20334 35.0606 7.35145 33.8995 8.98664V6.41209H28.0599V25.8256H33.8995V15.2839C33.8995 12.6397 35.3338 11.1785 37.5536 11.1785C39.7734 11.1785 41.2077 12.6397 41.2077 15.2839V25.8256Z",
    stroke: "url(#paint1_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7297 25.8256H56.5694V0.0800781H50.7297V25.8256Z",
    stroke: "url(#paint2_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2364 18.5542L64.831 6.41209H58.3083L66.0604 25.1646L61.6892 35.0453H67.9728L79.9254 6.41209H73.6076L69.2364 18.5542Z",
    stroke: "url(#paint3_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5353 9.16059V6.41209H81.6956V35.0801H87.5353V23.1119C88.5939 24.7471 90.6088 26.1039 93.4091 26.1039C98.0877 26.1039 101.81 22.2073 101.81 16.0841C101.81 9.96079 98.0877 6.13376 93.4091 6.13376C90.6088 6.13376 88.5939 7.45582 87.5353 9.16059ZM95.8679 16.0841C95.8679 19.1805 93.8872 20.92 91.6674 20.92C89.4818 20.92 87.5011 19.2153 87.5011 16.1188C87.5011 13.0224 89.4818 11.3177 91.6674 11.3177C93.8872 11.3177 95.8679 12.9876 95.8679 16.0841Z",
    stroke: "url(#paint4_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.532 25.8256H110.372V0.0800781H104.532V25.8256Z",
    stroke: "url(#paint5_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.101 16.0841C113.101 22.2073 116.824 26.1039 121.468 26.1039C124.302 26.1039 126.317 24.7819 127.376 23.0771V25.8256H133.216V6.41209H127.376V9.16059C126.351 7.45582 124.337 6.13376 121.502 6.13376C116.824 6.13376 113.101 9.96079 113.101 16.0841ZM127.376 16.1188C127.376 19.2153 125.429 20.92 123.21 20.92C121.024 20.92 119.043 19.1805 119.043 16.0841C119.043 12.9876 121.024 11.3177 123.21 11.3177C125.429 11.3177 127.376 13.0224 127.376 16.1188Z",
    stroke: "url(#paint6_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.875 18.5542L141.47 6.41209H134.947L142.699 25.1646L138.328 35.0453H144.612L156.564 6.41209H150.247L145.875 18.5542Z",
    stroke: "url(#paint7_linear_5879_17730)",
    strokeWidth: 30,
    mask: "url(#path-1-inside-1_5879_17730)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5879_17730",
    x1: 78.5645,
    y1: 0.0800781,
    x2: 78.5645,
    y2: 35.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullAnimated);
export default __webpack_public_path__ + "static/media/logo_full_animated.f72f0a5c0f47f166c46382db62d232f6.svg";
export { ForwardRef as ReactComponent };